import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import { surrealRecordSchema } from "./surreal-record";

export const personSchema = surrealRecordSchema.extend({
  personalIdentificationNumber: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  additionalData: additionalDataSchema,
});

export type Person = z.infer<typeof personSchema>;

export function getPersonSchemaAdditionalFields(additionalFields: {
  person: typeof additionalDataSchema;
}): typeof personSchema {
  return personSchema.extend({
    additionalData: additionalFields.person,
  });
}
